import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import FullLoader from 'components/Loader/FullLoader';
import { useNavigationTracker } from 'hooks/common/useNavigationTracker';

export function PrivateRoute() {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Track SPA route changes for authenticated users. Placed here because all
  // private routes render through PrivateRoute, giving us a single mount point
  // inside the React Router context without touching every page component.
  useNavigationTracker();

  if (loading) return <FullLoader />;

  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
}
